import React from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { RoiReportDetail } from '../../../components/Pleri/components/Settings/RoiReports';

export const Route = createFileRoute('/settings/roi-reports/$month')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = useParams({ from: '/settings/roi-reports/$month' });
  const month = params?.month;

  return (
    <div className="flex h-full w-full flex-col overflow-y-auto bg-white dark:bg-gray-900">
      <div className="mx-auto w-full max-w-7xl flex-1 px-6 py-12 sm:px-8">
        <RoiReportDetail month={month} />
      </div>
    </div>
  );
}
